export default __webpack_public_path__ + "static/media/c-tiong-bahru.a0fc4a89.png";